import { registerPlugin } from '@capacitor/core';
var TextToSpeech = registerPlugin('TextToSpeech', {
  web: function web() {
    return import('./web').then(function (m) {
      return new m.TextToSpeechWeb();
    });
  }
}); // Warm up

if ('speechSynthesis' in window) {
  window.speechSynthesis;
}

export * from './definitions';
export { TextToSpeech };